import {Component, Input, OnInit} from '@angular/core';

import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  templateUrl: './merge-modal.html'
})
export class MergeModal implements OnInit {

  @Input() availableKeys: string[] = [];

  keySelectedMap: Map<string, boolean> = new Map();

  constructor(private activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.availableKeys
      .filter(o => o && o !== 'id')
      .forEach(o => this.keySelectedMap.set(o, false));
  }

  apply() {
    const selectedKeys: string[] = [];
    this.keySelectedMap.forEach((selected, key) => {
      if (selected) {
        selectedKeys.push(key);
      }
    });
    this.activeModal.close(selectedKeys);
  }

  close() {
    this.activeModal.close();
  }
}